export enum EFilesQueryKeys {
  getFileById = "getFileById",
}

export const FILES_ENDPOINTS = {
  ROOT: "/files",
};
